import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import logoHeader from "../../../assets/fluxmed-logo-horizontal.png";
import { CircularLoading, ContentBoxTitle, SecondaryButton } from "../../../components/common";
import { SubscriptionService } from "../../../services/subscription/SubscriptionService";
import { SubscriptionCard } from "./SubscriptionCard";
import { currentFeatures } from "@/configs/Settings";

interface IProps {
  setSelectedPlan: (plan: any) => void;
  handleNext: () => void;
  handleBack?: () => void;
}

type SubscriptionPlanItem = {
  plan?: {
    external_reference?: string | number;
    back_url?: string;
  };
  [key: string]: unknown;
};

export function SubscriptionPlan({ setSelectedPlan, handleNext, handleBack }: IProps) {
  const [paymentOptions, setPaymentOptions] = useState<SubscriptionPlanItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const subscriptionService = new SubscriptionService();

  const fetchAllSubscriptionPlans = async () => {
    const organizationIdFromStorage = localStorage.getItem("organizationValue");
    const organizationId = organizationIdFromStorage;

    const allPlans = (await subscriptionService.getSubscriptionPlans({
      organizationId,
    })) as unknown as SubscriptionPlanItem[];

    console.log("Planos recebidos:", allPlans);
    // Filtra os planos removendo aqueles com external_reference "pos-atendimento"
    const excludedPlans = ["pos-atendimento"]; // Array de planos a serem excluídos

    let filteredPlans = allPlans.filter(
      (plan) => !excludedPlans.includes(String(plan?.plan?.external_reference ?? ""))
    );

    const isDevelopment =
      import.meta.env.VITE_ENV === "development";

    const allowedBackUrlParts = currentFeatures?.defaultApp
      ? isDevelopment
        ? ["fluxmed", "mercadopago"]
        : ["fluxmed"]
      : ["fluxvet"];

    filteredPlans = filteredPlans.filter((plan) => {
      const backUrl = plan?.plan?.back_url;
      if (typeof backUrl !== "string") return false;
      return allowedBackUrlParts.some((part) => backUrl.includes(part));
    });

    return filteredPlans && Array.isArray(filteredPlans) ? filteredPlans : [];
  };

  useEffect(() => {
    setLoading(true);
    const fetchPaymentOptions = async () => {
      try {
        const options = await fetchAllSubscriptionPlans();
        console.log("Opções de pagamento:", options);
        setPaymentOptions(options);
      } catch (err) {
        console.error("Erro ao buscar planos de assinatura:", err);
        setPaymentOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentOptions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePlanSelection = (plan: any) => {
    console.log("Plano selecionado:", plan);
    setSelectedPlan(plan);
    handleNext();
  };

  return (
    <Stack alignItems="center" spacing={10}>
      <Stack alignItems="center" spacing={2}>
        <img src={logoHeader} alt="Logo fluxmed" width={185} height="auto" />
        <ContentBoxTitle>Faça a sua assinatura</ContentBoxTitle>
      </Stack>
      <Stack spacing={6} justifyContent="center" alignItems="center">
        {loading ? (
          <CircularLoading />
        ) : paymentOptions.length > 0 ? (
          <Stack direction="row" spacing={3}>
            {paymentOptions.map((plan, index) => (
              <SubscriptionCard
                key={index}
                option={plan}
                onSelectPlan={handlePlanSelection}
              />
            ))}
          </Stack>
        ) : (
          <Typography>
            Nenhum plano de assinatura disponível no momento.
          </Typography>
        )}
        {handleBack && (
          <SecondaryButton 
            width="300px"
            height="42px"
            onClick={handleBack}
          >
            Voltar para escolha do plano
          </SecondaryButton>
        )}
      </Stack>
    </Stack>
  );
}
